import React, { useState } from "react";
import "../ContactComponent/ContactComponentCss/VillageFormMap.css";
import emailjs from "@emailjs/browser";

import villageBg from "../Images/village.jpg";
import mapImg from "../Images/graph.png";   

export default function VillageFormMap() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      await sendEmailWithEmailJS();
      setSubmitStatus("success");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending email:", error);
      
      if (error.text?.includes('service ID not found')) {
        setSubmitStatus("service_not_found");
      } else if (error.text?.includes('Public Key')) {
        setSubmitStatus("invalid_key");
      } else {
        setSubmitStatus("error");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendEmailWithEmailJS = async () => {
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      time: new Date().toLocaleString(),
      to_email: "info@grampanchayatnagthane.in",
      reply_to: formData.email,
      subject: `New Message from ${formData.firstName} ${formData.lastName} - Gram Panchayat Nagthane`,
    };

    // ✅ EmailJS Credentials
    const serviceID = "service_9832ngu"; 
    const templateID = "template_qwxkimg";
    const publicKey = "B3IpNzeRsF-enX9zr";

    console.log("Attempting to send email...", templateParams);
    const response = await emailjs.send(serviceID, templateID, templateParams, publicKey);
    console.log("Email sent successfully!", response);
    return response;
  };

  return (
    <div className="vm-wrapper">

      {/* ✅ LEFT FORM SECTION */}
      <div className="vm-left">
        <img src={villageBg} className="vm-bg" alt="Village Background" />

        <div className="vm-content">
          <h1>आपला सहयोग, आमची प्रगती</h1>
          <h2>चला एकत्र येऊन आपल्या गावाचं उज्ज्वल भविष्य घडवूया!</h2>

          <form className="vm-form" onSubmit={handleSubmit}>
            <div className="vm-row">
              <div className="vm-field">
                <label>नाव</label>
                <input 
                  type="text" 
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="vm-field">
                <label>आडनाव</label>
                <input 
                  type="text" 
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="vm-row">
              <div className="vm-field">
                <label>ईमेल</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="vm-field">
                <label>संपर्क क्रमांक</label>
                <input 
                  type="tel" 
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="vm-field">
              <label>आपला संदेश</label>
              <textarea 
                rows="3" 
                placeholder="तुमचा संदेश लिहा..." 
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            {/* Status Messages */}
            {submitStatus === "success" && (
              <div className="vm-status-message vm-success">
                धन्यवाद! आपला संदेश यशस्वीरित्या पाठवला गेला आहे.
              </div>
            )}

            {submitStatus === "error" && (
              <div className="vm-status-message vm-error">
                क्षमस्व! संदेश पाठवताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.
              </div>
            )}

            {submitStatus === "service_not_found" && (
              <div className="vm-status-message vm-error">
                सेवा उपलब्ध नाही. कृपया कॉन्फिगरेशन तपासा.
              </div>
            )}

            {submitStatus === "invalid_key" && (
              <div className="vm-status-message vm-error">
                अवैध API की. कृपया व्यवस्थापकाशी संपर्क साधा.
              </div>
            )}

            <button 
              type="submit" 
              className="vm-btn" 
              disabled={isSubmitting}
            >
              {isSubmitting ? "पाठवत आहे..." : "सबमिट करा"}
            </button>

            {/* ✅ Footer */}
            <div className="vm-footer">
              <p>
                ग्रामपंचायत कार्यालय, नागठाणे <br />
                नागठाणे, तालुका – सातारा, जिल्हा – सातारा, महाराष्ट्र – (४१५ ५१९)
              </p>

              <div className="vm-contact">
                <p>📞 +९१ ९८२३५९९२०५</p>
                <p>📧 info@grampanchayatnagthane.in</p>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ✅ RIGHT MAP SECTION */}
     <div 
  className="vm-right" 
  onClick={() => window.open("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3803.733495395596!2d74.04552737550655!3d17.56787068335047!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc22fe8a9a2b7d1%3A0xcbaf47b2fea38dd4!2sGram%20Panchait%20Karyalay%20Nagthane!5e0!3m2!1sen!2sin!4v1764309154186!5m2!1sen!2sin", "_blank")}
  style={{ cursor: "pointer" }}
>
  <img src={mapImg} className="vm-map" alt="Map Location" />
</div>

    </div>
  );
}
